import React from 'react';
import { ROUTES } from './constants';
import { Route } from 'circe/routing/provider';
import { Loadable } from 'circe/loadable/provider';
import { AUTHORITIES } from './constants';
import RequireAuth from 'circe/authorization/components/AuthorizationRoute';
import { loadComponent } from 'domain/layout/utils';

const dashboardContainer = loadComponent(() => import('./container'));
const authorizeDashboardContainer = RequireAuth(dashboardContainer, AUTHORITIES, '/');

const Routes = () => (
  <React.Fragment>
    <Route exact path={ROUTES.ROOT} key={ROUTES.ROOT} component={authorizeDashboardContainer} />
  </React.Fragment>
);

export default Routes;
